import moment from 'moment-timezone';
import { R } from '@core/utils/r';
import { TimeInput, toMoment, timeRange } from '@core/utils/time';
import { CalendarEventIdentifier, CalendarTaskAssignment } from '@business/entities/calendar_event';

export function getMonths() {
  return moment.months();
}

export function getShortMonths() {
  return moment.monthsShort();
}

export function getNYears(n: number, startFrom?: TimeInput) {
  const startDate = toMoment(startFrom);
  const endDate = startDate.clone().add(n, 'years');
  return timeRange(startDate, endDate, 'years').map(m => toMoment(m).format('YYYY'));
}

export function getTaskAssignmentTitle(type: CalendarTaskAssignment) {
  switch (type) {
    case CalendarTaskAssignment.client:
      return 'Client';
    case CalendarTaskAssignment.office:
      return 'Office';
    case CalendarTaskAssignment.pm:
      return 'Project Manager';
    case CalendarTaskAssignment.subContractor:
      return 'Subcontractor';
    case CalendarTaskAssignment.salesPerson:
      return 'Sales Person';
  }
}

export function getIdentifierTitle(identifier: CalendarEventIdentifier): string {
  switch (identifier) {
    case CalendarEventIdentifier.folderPrinted:
      return 'Folder Printed';
    case CalendarEventIdentifier.permitProcessed:
      return 'Permit Processed';
    case CalendarEventIdentifier.invoice1Sent:
      return 'Invoice 1 Sent';
    case CalendarEventIdentifier.invoice1Received:
      return 'Invoice 1 Received';
    case CalendarEventIdentifier.invoice2Sent:
      return 'Invoice 2 Sent';
    case CalendarEventIdentifier.invoice2Received:
      return 'Invoice 2 Received';
    case CalendarEventIdentifier.invoice3Sent:
      return 'Invoice 3 Sent';
    case CalendarEventIdentifier.invoice3Received:
      return 'Invoice 3 Received';
    case CalendarEventIdentifier.payReferralFee:
      return 'Pay Referral Fee';
    case CalendarEventIdentifier.surveySent:
      return 'Survey Sent';
    default:
      return identifier;
  }
}
